import {
  CLINICAL_DASHBOARD_COLUMNS,
  clinicalDashboardHref,
  type ClinicalDashboardItem,
} from "@/lib/prism-clinical-dashboard"
import type { NavLayoutSpec, NavLinkSpec } from "@exxatdesignux/product-framework"

function hubItemFromDashboard(
  slug: string,
  item: ClinicalDashboardItem,
): NavLinkSpec {
  const url = clinicalDashboardHref(item, slug)
  return {
    key: item.id,
    title: item.label,
    url,
    iconClass: item.icon,
    iconActiveClass: item.icon.replace("fa-light", "fa-solid"),
  }
}

/** Full Clinical Education IA in the primary sidebar (launcher grid hidden). */
export function buildPrismSidebarNavLayout(slug: string): NavLayoutSpec {
  return {
    preamble: [
      {
        key: "dashboard",
        title: "Dashboard",
        url: `/${slug}/dashboard`,
        iconClass: "fa-light fa-grid-2",
        iconActiveClass: "fa-solid fa-grid-2",
      },
    ],
    sections: CLINICAL_DASHBOARD_COLUMNS.map(column => ({
      key: column.id,
      label: column.title,
      items: column.items.map(item => hubItemFromDashboard(slug, item)),
    })),
  }
}
